var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"text-404"},[_vm._v("404")]),_c('div',{staticClass:"text"},[_vm._v("页面走丢了~~")])])])
}]

export { render, staticRenderFns }